import { Breakpoint, type SliderConfig } from '@jsmdg/yoshi';

export const boxGifSliderConfig: SliderConfig = {
    spaceBetween: 16,
    slidesPerView: 1.25,
    slidesPerGroup: 1,
    showPagination: false,
    showNavigation: false,
    breakpoints: {
        [Breakpoint.XS]: { slidesPerView: 2.25, slidesPerGroup: 1, spaceBetween: 16 },
        [Breakpoint.SM]: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 24 },
        [Breakpoint.LG]: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 32 },
    },
};
